/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TripForwardingRelationshipPutRequest
 */
export interface TripForwardingRelationshipPutRequest {
    /**
     * 
     * @type {string}
     * @memberof TripForwardingRelationshipPutRequest
     */
    verificationToken: string;
}

/**
 * Check if a given object implements the TripForwardingRelationshipPutRequest interface.
 */
export function instanceOfTripForwardingRelationshipPutRequest(value: object): value is TripForwardingRelationshipPutRequest {
    if (!('verificationToken' in value) || value['verificationToken'] === undefined) return false;
    return true;
}

export function TripForwardingRelationshipPutRequestFromJSON(json: any): TripForwardingRelationshipPutRequest {
    return TripForwardingRelationshipPutRequestFromJSONTyped(json, false);
}

export function TripForwardingRelationshipPutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripForwardingRelationshipPutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'verificationToken': json['verification_token'],
    };
}

export function TripForwardingRelationshipPutRequestToJSON(json: any): TripForwardingRelationshipPutRequest {
    return TripForwardingRelationshipPutRequestToJSONTyped(json, false);
}

export function TripForwardingRelationshipPutRequestToJSONTyped(value?: TripForwardingRelationshipPutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'verification_token': value['verificationToken'],
    };
}

